module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_studio_free-a603621a84b3b072cd51c527bc2123ae.jpg";